package models

enum class PostStatus(val status: String, val color: String) {
    PaymentPending("PAYMENT_PENDING", "#ffc107"),
    InReview("IN_REVIEW", "#17a2b8"),
    Live("LIVE", "#28a745"),
    Expired("EXPIRED", "#dc3545"),
    Disabled("DISABLED", "#6c757d")
}